import Components from "slotworks/components/components";
import PromptContent from "slotworks/components/prompt/prompt-content";
import Layers from "slotworks/graphics/layers/layers";
import Gamestate from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";

export default class RetriggerFreespins extends State {

    public onEnter() {
        SmartUIFlags.set(SmartUIFlag.PROMPT, true);

        this.showPrompt();
    }

    public complete() {
        SmartUIFlags.set(SmartUIFlag.PROMPT, false);

        super.complete();
    }

    protected showPrompt(prompt?: PromptContent) {
        if (!prompt && Layers.Prompts.hasAnyScene(["freespinsretrigger", "freespinswin", "freespins"])) {
            prompt = new PromptContent(["freespinsretrigger", "freespinswin", "freespins"]);
        }

        if (prompt) {
            const record = Gamestate.getCurrentGame().getCurrentRecord();

            prompt.setText("winMessage", Services.translations.get("fs.rtr", { VALUE: record.getFreespinsWon(), SPINS: record.getFreespinsWon() }));
            prompt.setText("value", record.getFreespinsWon().toString());

            Components.prompt.showPrompt(prompt).then(() => this.complete());

        } else {
            this.complete();
        }
    }
}
